import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';
import HeroCarousel from './components/HeroCarousel';
import ContentCard from '@/components/feature/ContentCard';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot);
  const newArticles = articles.filter((a) => a.isNew);
  const topRated = [...articles].sort((a, b) => b.rating - a.rating).slice(0, 6);

  const seoJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '香蕉影视',
    url: 'https://www.xiangjiaoys.com/',
    description: '香蕉影视提供高清免费在线观看，不缓冲秒开，最新热播电影、电视剧、综艺大全，全集免费在线看，高清流畅不卡顿，追剧必备。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.xiangjiaoys.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoJsonLd) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroCarousel />

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">热门推荐</h2>
              <Link
                to="/category/movie"
                className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer flex items-center gap-1 whitespace-nowrap transition-colors"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
              {hotArticles.map((article) => (
                <ContentCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-1">探索分类</h2>
              <p className="text-sm text-foreground-500">发现你喜欢的影视类型</p>
            </div>
            <div className="flex flex-wrap gap-2 md:gap-3">
              {categories.map((cat) => {
                const count = articles.filter((a) => a.categorySlug === cat.slug).length;
                return (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-4 py-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 cursor-pointer transition-all group whitespace-nowrap"
                  >
                    <span className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                      <i className={`${cat.icon} text-sm`}></i>
                    </span>
                    <div>
                      <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
                      <span className="text-xs text-foreground-500 ml-2">{count}部</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">最新上线</h2>
              <Link
                to="/category/movie"
                className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer flex items-center gap-1 whitespace-nowrap transition-colors"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
              {newArticles.map((article) => (
                <ContentCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">高分必看</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
              {topRated.map((article) => (
                <ContentCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                追剧不等待，高清秒加载
              </h2>
              <p className="text-foreground-600 text-sm md:text-base mb-6">
                香蕉影视采用先进的视频加速技术，确保您在观影过程中享受<strong>零缓冲、高画质</strong>的流畅体验。
                无论您是在家中还是通勤路上，打开即看，永不卡顿。
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <div className="text-center px-6">
                  <div className="text-3xl font-heading font-bold text-primary-500">1000+</div>
                  <div className="text-xs text-foreground-500 mt-1">影视资源</div>
                </div>
                <div className="text-center px-6">
                  <div className="text-3xl font-heading font-bold text-accent-500">4K</div>
                  <div className="text-xs text-foreground-500 mt-1">超清画质</div>
                </div>
                <div className="text-center px-6">
                  <div className="text-3xl font-heading font-bold text-primary-500">0</div>
                  <div className="text-xs text-foreground-500 mt-1">缓冲等待</div>
                </div>
                <div className="text-center px-6">
                  <div className="text-3xl font-heading font-bold text-accent-500">24H</div>
                  <div className="text-xs text-foreground-500 mt-1">全天更新</div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}